import { BoxProps, boxClasses, boxPropsKeys } from "./theme/box";
import { TextProps, textClasses, textPropKeys } from "./theme/typography";
export interface StyleProps extends BoxProps, TextProps {}

export const stylePropKeys = new Set([...boxPropsKeys, ...textPropKeys]);

export function styleClasses(props: StyleProps) {
  return [...boxClasses(props), ...textClasses(props)];
}
